const STORAGE_VERSION = 'v1';
const DEFAULT_USER_KEY = 'anon';

let userKey = DEFAULT_USER_KEY;

function sanitizeUserKey(value) {
  const trimmed = String(value || '').trim();
  if (!trimmed) return DEFAULT_USER_KEY;
  return trimmed.replace(/[^a-zA-Z0-9._-]/g, '_').slice(0, 80) || DEFAULT_USER_KEY;
}

function todayStamp(now = new Date()) {
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function everKey(tourId) {
  return `sg-coach:${STORAGE_VERSION}:ever:${userKey}:${tourId}`;
}

function dayKey(stamp = todayStamp()) {
  return `sg-coach:${STORAGE_VERSION}:day:${userKey}:${stamp}`;
}

function readItem(key) {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function writeItem(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* private mode / quota */
  }
}

/** Set the storage namespace. Use username or id when authenticated; otherwise `anon`. */
export function setUserKey(nextKey) {
  userKey = sanitizeUserKey(nextKey);
  return userKey;
}

export function getUserKey() {
  return userKey;
}

export function hasCompletedTour(tourId) {
  if (!tourId) return false;
  return readItem(everKey(tourId)) === '1';
}

export function markTourComplete(tourId) {
  if (!tourId) return;
  writeItem(everKey(tourId), '1');
}

/** True when this user has not already recorded a daily tip for today. */
export function shouldShowDailyTip(now) {
  return readItem(dayKey(todayStamp(now))) !== '1';
}

export function markDailyTipShown(now) {
  writeItem(dayKey(todayStamp(now)), '1');
}
